// Laboratory price list dated 13 July 2026; "- Kč" is preserved from the source.
const laboratoryPrices = [
  {
    title: "Korunkové náhrady",
    items: [
      [
        "030411A",
        "KORUNKA ATRAUMATICKÁ FASETOVANÁ KOMPOZITNÍ - SIGNUM",
        "7 500 Kč",
        "7 800 Kč",
      ],
      ["30111", "KORUNKA PLÁŠŤOVÁ CELOKOVOVÁ", "- Kč", "1 200 Kč"],
      [
        "30411",
        "KORUNKA FASETOVANÁ KOMPOZITNÍ - SIGNUM",
        "6 400 Kč",
        "6 700 Kč",
      ],
      [
        "30511",
        "KORUNKA - CELOKERAMIKA/ ZIRKONOVÁ - CELOANATOMICKÁ",
        "8 800 Kč",
        "9 100 Kč",
      ],
      [
        "30512",
        "KORUNKA - CELOKERAMIKA / ZIRKONOVÁ - VRSTVENÁ",
        "9 000 Kč",
        "9 300 Kč",
      ],
      [
        "30513",
        "KORUNKA - CELOKERAMIKA - PRESOVANÁ CELOANATOMICKÁ, E-MAX",
        "9 100 Kč",
        "9 400 Kč",
      ],
      [
        "30514",
        "KORUNKA - CELOKERAMIKA - PRESOVANÁ VRSTVENÁ, E-MAX",
        "9 200 Kč",
        "9 500 Kč",
      ],
      ["30611", "KORUNKA - METALOKERAMIKA", "8 800 Kč", "9 100 Kč"],
      ["82101", "MODEL Z 3D TISKU", "500 Kč", "500 Kč"],
      ["85010", "INDIVIDUALIZACE PROTETICKÉ PRÁCE", "500 Kč", "500 Kč"],
    ],
  },
  {
    title: "Mezičleny můstku",
    items: [
      [
        "040211A",
        "ČLEN MŮSTKU ATRAUMATICKÝ FAZETOVANÝ KOMPOZIT- SIGNUM",
        "7 900 Kč",
        "8 100 Kč",
      ],
      [
        "120413",
        "PŘÍPLATEK RŮŽOVÁ ESTET. GING. ZA JEDEN ČLEN",
        "500 Kč",
        "500 Kč",
      ],
      ["40111", "ČLEN MŮSTKU CELOKOVOVÝ", "7 100 Kč", "7 300 Kč"],
      [
        "40211",
        "ČLEN MŮSTKU ESTETICKÝ FAZETOVANÝ KOMPOZIT- SIGNUM",
        "7 800 Kč",
        "8 000 Kč",
      ],
      [
        "40311",
        "ČLEN MŮSTKU - CELOKERAMIKA/ZIRKONOVÁ CELOANATOMICKÁ",
        "8 500 Kč",
        "8 700 Kč",
      ],
      [
        "40312",
        "ČLEN MŮSTKU - CELOKERAMIKA/ZIRKONOVÁ VRSTVENÁ",
        "8 700 Kč",
        "8 900 Kč",
      ],
      [
        "40313",
        "ČLEN MŮSTKU - KERAMIKA PRESOVANÁ CELOANATOMICKÁ, E-MAX",
        "8 800 Kč",
        "9 000 Kč",
      ],
      [
        "40314",
        "ČLEN MŮSTKU - KERAMIKA PRESOVANÁ VRSTVENÁ, E-MAX",
        "8 900 Kč",
        "9 100 Kč",
      ],
      ["40315", "ČLEN MŮSTKU - METALOKERAMIKA", "8 500 Kč", "8 700 Kč"],
    ],
  },
  {
    title: "Opravy snímatelních náhrad",
    items: [
      [
        "100111",
        "OPRAVA PRASKLÉ NEBO ZLOMENÉ SNÍMATELNÉ NÁHRADY",
        "2 400 Kč",
        "2 600 Kč",
      ],
      [
        "100113",
        "OPRAVA PRASKLÉ NEBO ZLOMENÉ SNÍMATELNÉ NÁHRADY Z DEFLEXU",
        "2 500 Kč",
        "2 700 Kč",
      ],
      ["100211", "OPRAVA VYPADLÉHO ZUBU Z NÁHRADY", "2 100 Kč", "2 300 Kč"],
      [
        "100212",
        "OPRAVA VYPADLÉHO ZUBU Z NÁHRADY Z DEFLEXU",
        "2 200 Kč",
        "2 400 Kč",
      ],
      [
        "100311",
        "OPRAVA RETENČNÍCH PRVKŮ NÁHRADY - DO DVOU PRVKŮ",
        "2 100 Kč",
        "2 500 Kč",
      ],
      [
        "100411",
        "ROZŠÍŘENÍ BAZE NÁHRADY - 1 AŽ 8 ZUBŮ",
        "2 500 Kč",
        "3 100 Kč",
      ],
      [
        "100412",
        "ROZŠÍŘENÍ BAZE NÁHRADY Z DEFLEXU - 1 AŽ 8 ZUBU",
        "2 800 Kč",
        "3 400 Kč",
      ],
      ["121126", "ČIŠTĚNÍ SNÍMATELNÉ NÁHRADY", "1 400 Kč", "1 400 Kč"],
    ],
  },
  {
    title: "Rebaze",
    items: [
      [
        "100511",
        "REBAZE ČSN RIGIDNÍM MATERIÁLEM, LABORATORNĚ ZHOTOVENÁ",
        "4 800 Kč",
        "5 700 Kč",
      ],
      [
        "100512",
        "REBAZE CELKOVÉ NÁHRADY S RIGIDNÍM MATERIÁLEM, LABORATORNĚ ZHOTOVENÁ",
        "5 000 Kč",
        "5 900 Kč",
      ],
    ],
  },
  {
    title: "Modely",
    items: [
      [
        "10111",
        "REKONSTRUKCE MEZIČELISTNÍCH VZTAHŮ - SKUSOVÉ ŠABLONY",
        "- Kč",
        "1 200 Kč",
      ],
      ["120201", "STUDIJNÍ MODEL S OTISKEM", "1 100 Kč", "1 100 Kč"],
      ["120203", "ANALÝZA MODELU V ARTIKULÁTORU", "200 Kč", "200 Kč"],
      [
        "120205",
        "FUNKČNÍ OTISK HTN - INDIVIDUÁLNÍ LŽÍCE",
        "2 200 Kč",
        "2 200 Kč",
      ],
      [
        "120206",
        "FUNKČNÍ OTISK DTN - INDIVIDUÁLNÍ LŽÍCE",
        "2 200 Kč",
        "2 200 Kč",
      ],
      [
        "120207",
        "FUNKČNÍ OTISK OZUBENÉ ČELISTI - INDIVIDUÁLNÍ LŽÍCE",
        "2 200 Kč",
        "2 200 Kč",
      ],
      ["120214", "SPONOVÁ MODELACE NA PILÍŘOVÉ KORUNCE", "300 Kč", "300 Kč"],
      ["120218", "WAX-UP - JEDEN ZUB", "1 200 Kč", "1 200 Kč"],
    ],
  },
  {
    title: "Provizorní fixní náhrady",
    items: [
      [
        "120223",
        "VÝZTUŽNÝ DRÁT DO PROVIZORNÍHO MŮSTKU za člen",
        "50 Kč",
        "50 Kč",
      ],
      ["181617", "OPRAVA PÍSKOVÁNÍ KORUNKY", "200 Kč", "200 Kč"],
      ["181618", "PODBARVENÍ INLEJE POD ZIRCON", "300 Kč", "300 Kč"],
      [
        "30711",
        "PROVIZORNÍ KORUNKA - PMMA - frézovaná",
        "2 300 Kč",
        "2 600 Kč",
      ],
      ["40401", "ČLEN PROVIZORNÍHO MŮSTKU", "2 600 Kč", "2 600 Kč"],
    ],
  },
  {
    title: "Pomocné výrobky a procesy",
    items: [
      ["120226", "PŘESTAVBA SNÍMATELNÝCH NÁHRAD", "1 200 Kč", "1 200 Kč"],
      [
        "120230",
        "INDIVIDUÁLNĚ PROBARVENÁ GINGIVA - SNÍMATELNÉ NÁHRADY",
        "1 500 Kč",
        "1 500 Kč",
      ],
      [
        "400",
        "VÝZTUŽ DO ČSN PREFABRIKOVANÁ - DRÁT, MŘÍŽKA",
        "500 Kč",
        "500 Kč",
      ],
      ["82005", "FÓLIOVÝ MEZERNÍK", "3 700 Kč", "3 700 Kč"],
    ],
  },
  {
    title: "Onlej",
    items: [
      ["120316", "ONLEJ Z KOMPOZITNÍHO PLASTU", "6 700 Kč", "6 700 Kč"],
      ["120317", "ONLEJ CELOKERAMICKÁ", "7 400 Kč", "7 400 Kč"],
    ],
  },
  {
    title: "Imediátní snímatelné náhrady",
    items: [
      [
        "121001",
        "ČÁSTEČNÁ SNÍMATELNÁ NÁHRADA IMEDIÁTNÍ HORNÍ - DO 4 ZUBŮ",
        "6 900 Kč",
        "6 900 Kč",
      ],
      [
        "121002",
        "ČÁSTEČNÁ SNÍMATELNÁ NÁHRADA IMEDIÁTNÍ HORNÍ - DO 9 ZUBŮ",
        "7 100 Kč",
        "7 100 Kč",
      ],
      [
        "121003",
        "ČÁSTEČNÁ SNÍMATELNÁ NÁHRADA IMEDIÁTNÍ HORNÍ - 10 A VÍCE ZUBŮ",
        "7 300 Kč",
        "7 300 Kč",
      ],
      [
        "121004",
        "ČÁSTEČNÁ SNÍMATELNÁ NÁHRADA IMEDIÁTNÍ DOLNÍ - DO 4 ZUBŮ",
        "6 900 Kč",
        "6 900 Kč",
      ],
      [
        "121005",
        "ČÁSTEČNÁ SNÍMATELNÁ NÁHRADA IMEDIÁTNÍ DOLNÍ - DO 9 ZUBŮ",
        "7 100 Kč",
        "7 100 Kč",
      ],
      [
        "121006",
        "ČÁSTEČNÁ SNÍMATELNÁ NÁHRADA IMEDIÁTNÍ DOLNÍ - 10 A VÍCE ZUBŮ",
        "7 300 Kč",
        "7 300 Kč",
      ],
      [
        "121011",
        "CELKOVÁ SNÍMATELNÁ NÁHRADA IMEDIÁTNÍ HORNÍ - BEZ ŠABLONY A BEZ ZKOUŠKY MODELU NÁHRADY",
        "6 300 Kč",
        "6 300 Kč",
      ],
      [
        "121012",
        "CELKOVÁ SNÍMATELNÁ NÁHRADA IMEDIÁTNÍ DOLNÍ - BEZ ŠABLONY A BEZ ZKOUŠKY MODELU NÁHRADY",
        "6 300 Kč",
        "6 300 Kč",
      ],
      [
        "121013",
        "CELKOVÁ SNÍMATELNÁ NÁHRADA IMEDIÁTNÍ HORNÍ - SE ŠABLONOU A SE ZKOUŠKOU MODELU NÁHRADY",
        "8 500 Kč",
        "8 500 Kč",
      ],
      [
        "121014",
        "CELKOVÁ SNÍMATELNÁ NÁHRADA IMEDIÁTNÍ DOLNÍ - SE ŠABLONOU A SE ZKOUŠKOU MODELU NÁHRADY",
        "8 500 Kč",
        "8 500 Kč",
      ],
    ],
  },
  {
    title: "Tepelné tvarování fólií",
    items: [
      ["121201", "CHRÁNIČ PRO SPORTOVCE - HČ", "3 400 Kč", "3 400 Kč"],
      ["121202", "NOSIČ PRO BĚLENÍ ZUBŮ - DVĚ ČELISTI", "3 300 Kč", "3 300 Kč"],
      [
        "121204",
        "OCHRANNÁ DLAHA - BRUXISMUS, OCHRANA PROTETICKÉ PRÁCE",
        "2 900 Kč",
        "2 900 Kč",
      ],
    ],
  },
  {
    title: "Čistění slitin zlata",
    items: [
      ["185014", "ČIŠTĚNÍ DO 4 ČLENŮ", "500 Kč", "500 Kč"],
      ["185015", "ČIŠTĚNÍ OD 5 ČLENŮ", "800 Kč", "800 Kč"],
    ],
  },
  {
    title: "Estetické snímatelné náhrady",
    items: [
      [
        "185016",
        "ČSN OST. H. - ACETAL - 6 A VÍCE ZUBŮ",
        "14 100 Kč",
        "14 100 Kč",
      ],
      [
        "185017",
        "ČSN OST. D. - ACETAL - 6 A VÍCE ZUBŮ",
        "14 100 Kč",
        "14 100 Kč",
      ],
      ["185018", "ČSN OST. H. - ACETAL - 1-2 ZUBY", "11 100 Kč", "11 100 Kč"],
      [
        "185019",
        "ČSN OST. D. - ACETAL - 6 A VÍCE ZUBŮ",
        "11 100 Kč",
        "11 100 Kč",
      ],
      [
        "185021",
        "ČSN OST. H. - ACETAL - 6 A VÍCE ZUBŮ",
        "13 100 Kč",
        "13 100 Kč",
      ],
      ["186020", "ČSN OST. H. - ACETAL - 3-5 ZUBŮ", "13 100 Kč", "13 100 Kč"],
    ],
  },
  {
    title: "Inlej",
    items: [
      [
        "20112",
        "INLEJ KOŘENOVÁ, JEDEN KANÁLEK, NEPŘÍMÁ LITÁ, PEEK - frézovaná",
        "3 700 Kč",
        "3 700 Kč",
      ],
      [
        "20114",
        "INLEJ KOŘENOVÁ, DVA KANÁLKY, NEPŘÍMÁ, LITÁ, PEEK- frézovaná",
        "4 400 Kč",
        "4 800 Kč",
      ],
    ],
  },
  {
    title: "Částečné snímatelné náhrady",
    items: [
      [
        "60111",
        "ČSN - ZÁKLADNÍ, HORNÍ, S JEDNODUCHÝMI RETENČNÍMI PRVKY",
        "- Kč",
        "3 900 Kč",
      ],
      [
        "60121",
        "ČSN - ZÁKLADNÍ, DOLNÍ, S JEDNODUCHÝMI RETENČNÍMI PRVKY",
        "- Kč",
        "3 900 Kč",
      ],
      [
        "60213",
        "ČSN OST. H. - SKELETOVÁ, S LITOU DESKOU - 2 KOTEVNÍ PRVKY",
        "10 600 Kč",
        "13 100 Kč",
      ],
      [
        "60214",
        "ČSN OST. H. - SKELETOVÁ, S LITOU DESKOU - 3 A VÍCE KOT. PRVKŮ",
        "10 700 Kč",
        "13 200 Kč",
      ],
      [
        "60215",
        "ČSN OST. H. - SKELETOVÁ, SE SPOJOVACÍM TŘMENEM - 2 KOTEVNÍ PRVKY",
        "11 100 Kč",
        "13 600 Kč",
      ],
      [
        "60216",
        "ČSN OST. H. - SKELETOVÁ, SE SPOJOVACÍM TŘMENEM - 3 A VÍCE KOTEVNÍCH PRVKŮ",
        "11 100 Kč",
        "13 600 Kč",
      ],
      [
        "60233",
        "ČSN OST. D. - SKELETOVÁ, SE SPOJOVACÍM PODJAZYKOVÝM TŘMENEM - 2 KOTEVNÍ PRVKY",
        "11 100 Kč",
        "13 600 Kč",
      ],
      [
        "60234",
        "ČSN OST. D. - SKELETOVÁ, SE SPOJOVACÍM PODJAZYKOVÝM TŘMENEM - 3 A VÍCE KOTEVNÍCH PRVKŮ",
        "11 100 Kč",
        "13 600 Kč",
      ],
      [
        "60235",
        "ČSN OST. D. - SKELETOVÁ, S LITOU DESKOU - 2 KOTEVNÍ PRVKY",
        "10 600 Kč",
        "13 100 Kč",
      ],
      [
        "60236",
        "ČSN OST. D. - SKELETOVÁ, S LITOU DESKOU - 3 A VÍCE KOT. PRVKŮ",
        "10 700 Kč",
        "13 200 Kč",
      ],
    ],
  },
  {
    title: "Celkové snímatelné náhrady",
    items: [
      [
        "70111",
        "CELKOVÁ SNÍMATELNÁ NÁHRADA ZÁKLADNÍ, HORNÍ",
        "- Kč",
        "4 400 Kč",
      ],
      [
        "70121",
        "CELKOVÁ SNÍMATELNÁ NÁHRADA ZÁKLADNÍ, DOLNÍ",
        "- Kč",
        "4 400 Kč",
      ],
      [
        "70213",
        "CELKOVÁ SNÍMATELNÁ NÁHRADA OSTATNÍ HORNÍ - DEFLEX",
        "11 600 Kč",
        "16 200 Kč",
      ],
      [
        "70233",
        "CELKOVÁ SNÍMATELNÁ NÁHRADA OSTATNÍ DOLNÍ - DEFLEX",
        "11 600 Kč",
        "16 200 Kč",
      ],
      [
        "70211",
        "CELKOVÁ SNÍMATELNÁ NÁHRADA OSTATNÍ, HORNÍ",
        "9 500 Kč",
        "14 100 Kč",
      ],
    ],
  },
].map(({ title, items }) => ({
  title,
  items: items.map(([code, name, price, uninsuredPrice]) => ({
    code,
    name,
    price,
    uninsuredPrice,
  })),
}));

export default laboratoryPrices;
